export default __webpack_public_path__ + "static/media/banner1.c1c5dd38.png";